import { Route as BrowserRoute, Outlet  } from 'react-router-dom';
import WrapperTitle from '../WrapperTitle/WrapperTitle';
import RequireAuth from "/src/features/auth/hooks/requireAuth";
import UpdateUser from "/src/features/user/hooks/updateUser";
import { useLocation } from 'react-router-dom';

function BuilderRoute(route, index) {
    const Component = () => <WrapperTitle route={route}/>

    
    const Page = ({isPublic}) => {
        if(isPublic) {
            return <Component/>;
        }

        return (
            <RequireAuth>
                <UpdateUser permissions={route.permissions ?? []}>
                    <Component/>
                </UpdateUser>
            </RequireAuth>
        )
    }
    
    return (   
        <BrowserRoute key={index} path={route.path}  isSidebar={route.isSidebar}  element={<Page isPublic={route.isPublic}/>}/>
    )
}

export default BuilderRoute;